<template>
	<div>
		<div class="row">
			<h1 class="page-header">{{ pageTitle }}</h1>
		</div>

		<div class="row">
			<div class="panel panel-info" v-loading="loading" element-loading-text="Uploading...">
				<div class="panel-heading">
					Data Loader Configuration
				</div>
				
				<div class="panel-body">

					<form @submit.prevent="uploadData">
						<div class="row">
							<div class="col-xs-12">
								<div class="form-group">
									<label>Import Type</label>
									<select class="form-control" v-model="form.format" required @change="updateConfiguration">
										<option value="" selected v-if="formats.length > 1">-- Please Select --</option>
										<option v-for="format in formats" :value="format.value">{{ format.label }}</option>
									</select>
									<p v-if="errors.format">{{ errors.format[0] }}</p>
								</div>
								<p class="help-block" v-if="configuration && configuration.description">
									{{ configuration.description}} <span v-if="configuration && configuration.help_url">
									For more information please <a :href="configuration.help_url" target="_new">click here</a>
								</span>
									
								</p>
								<div class="form-group" v-show="false">
									<label>Operation</label>
									<select class="form-control" v-model="form.operation" required>
										<option value="" selected>-- Please Select --</option>
										<option v-for="operation in operations" :value="operation">{{ operation }}</option>
									</select>
									<p v-if="errors.format">{{ errors.format[0] }}</p>
								</div>
<!--								<div class="checkbox">-->
<!--									<label>-->
<!--										<input type="checkbox" value="1" name="validate-only">-->
<!--										Validate Only-->
<!--									</label>-->
<!--								</div>-->
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<div class="form-group">
									<label>Upload a File</label>
									<input ref="fileInput" type="file" accept="text/csv" @change="setFile"/>
								</div>
								<p v-if="errors.file">{{ errors.file[0] }}</p>

							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<button type="submit" class="btn btn-primary">Upload</button>
							</div>
						</div>
					</form>
				</div>
				<table v-if="errors.length > 0" class="table table-condensed table-striped text-danger panel-body">
					<thead>
					<tr>
						<th>Row</th>
						<th>Errors</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="error in errors">
						<td>{{ error.row }}</td>
						<td>{{ error.errors }}</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="row table-responsive">
				<div class="panel panel-info">
					<div class="panel-heading">Preview<span class="pull-right">{{ this.parsed_data.data.length }} records</span></div>
				<table v-if="parsed" class="panel-body table table-condensed table-striped">
					<thead>
					<tr>
						<th>#</th>
						<th v-for="(header, key) in configuration.columns">
							{{ header }}
						</th>
					</tr>
					</thead>
					<tbody>
						<tr v-for="(row, rowKey) in parsed_data.data">
							<td>{{ rowKey + 1 }}</td>
							<td v-for="(column, columnKey) in configuration.columns">
								{{ parsed_data.data[rowKey][column] }}
							</td>
						</tr>
					</tbody>
				</table>
				</div>
		</div>

	</div>
</template>
<script>
import Papa from 'papaparse';
import {Message, Loading, DatePicker, Tooltip, Icon} from 'element-ui';
import {Component as Vuedal} from "vuedals";

export default {
	components: { Message, Loading },
	props: {
		// HTML is case insensitive. Vue converts kebab-case HTML props to camel-case
		// So in HTML this is page-title
		pageTitle: {
			type: String,
			default: 'Data Loader'
		},
		formats: {
			type: Array,
			default: []
		},
		operations: {
			type: Array,
			default: []
		}

	},
	data: function () {
		return {
			form: {
				file: null,
				format: "",
				operation: "Import"
			},
			result: {},
			errors: [],
			parsed_data: {
				data: [],
				errors: [],
				meta: [],
				headings: [],
			},
			parsed: false,
			configuration: null,
			loading: false
		}
	},
	computed: {
		headers() {
			return _.intersection(this.parsed_data.meta.fields, this.columns)
		}
	},
	mounted() {
		if (this.formats.length == 1) {
			this.form.format = this.formats[0].value;
			this.updateConfiguration();
		}
	},
	methods: {
		setFile(event) {
			this.resetPreview();
			console.log(event.target.files[0].name);
			const extension = event.target.files[0].name.split('.').pop().toLowerCase();
			if (extension !== 'csv') {
				this.$message({message: 'The selected file is not a CSV file.', type: 'error'});
				this.$refs.fileInput.value = null;
				return;
			}
			this.form.file = event.target.files[0];
			this.previewFile();
		},
		resetPreview() {
			this.parsed_data = {
				data: [],
				errors: [],
				meta: [],
				headings: [],
			};
			this.parsed = false;
			this.errors = [];
		},
		reset() {
			this.resetPreview();
			this.form.file = null;
			this.$refs.fileInput.value = null;
			this.form.operation = 'Import';
		},
		uploadData() {
			console.log('Submitting form');
			const formData = new FormData();
			formData.append('format', this.form.format);
			formData.append('operation', this.form.operation);
			formData.append('parameters', []);
			formData.append('data', JSON.stringify(this.parsed_data.data));
			this.errors = [];
			this.loading = true;
			
			axios.post('/club/dataloader', {
					format: this.form.format,
					operation: this.form.operation,
					parameters: [],
					data: this.parsed_data.data
				}, {
				headers: {
					'Content-Type': 'application/json'
					// 'Content-Type': 'multipart/form-data' // Need this if we post a file
				},
				timeout: 0
			})
			.then((response) => {
					console.log('Success');
					console.log(response);
					this.reset();
					this.$message({message: 'The file has been imported successfully.', type: 'success'});
			})
			.catch((error) => {
				console.log('Exception');
				console.log(error.response.data);
				this.$message({message: `There are ${error.response.data.invalid_row_count} invalid rows in the file - please check the details below.`, type: 'error'});
				this.errors = _.sortBy(error.response.data.errors, 'row');
			})
			.finally(() => {
				this.loading = false;
			});


		},
		previewFile()
		{
			if (this.form.file) {
				Papa.parse(this.form.file, {
					header: true,
					skipEmptyLines: true,
					step: (results, parser) => {
						// console.log("Row data:", results.data);
						// console.log("Row errors:", results.errors);
						// console.log("Row meta:", results.meta);
						if (this.includeRow(results.data)) {
							
							// results.data.
							//console.log('Unmapped data', results.data);
							// let data = _.mapKeys(results.data, (value, key) => { return this.configuration.columns[key]});
							// console.log('Mapped data', data);
							// data = _.pick(data, _.values(this.configuration.columns));
							// this.parsed_data.data.push(data);
							
							// Was working
							this.parsed_data.data.push(_.pick(results.data , this.configuration.columns));
							this.parsed_data.errors.push(results.errors);
							this.parsed_data.meta = results.meta;
							let headings = _.intersection(results.meta.fields, this.configuration.columns);
							this.parsed_data.headings = headings;
							let newheadings = headings.map((header) => { 
								console.log('header: ' . header); 
								return header.replace('\.','').replace('/',' ');
							});
							this.parsed_data.headings = newheadings;
							console.log('New headings',newheadings);
							this.parsed = true;
						}
					},
					complete: (results, file) => {
						// console.log("Parsing complete", results);
						// this.parsed_data = results;
						// this.parsed = true;
						// this.errors = results.errors
					},
					transformHeader: function(header) {
						console.log('Transforming header ' . header);
						return _.replace(header.trim(),'.','');
					}
				});
			}

		},
		updateConfiguration(format) {
			axios.get(`/api/club/dataloader/${this.form.format}/configuration`).then((response) => {
				this.configuration = response.data;
			});
			this.previewFile();
		},
		includeRow(data) {
			console.log(data);
			if (this.configuration == null) {
				return true;
			}
			if (this.configuration.filters == null) {
				return true;
			}
			// console.log('Filter logic: ', this.configuration.filters.logic);
			let matches_filter = false;
			if (this.configuration.filters.logic === 'AND') {
				// console.log('For AND logic we default to TRUE and set to FALSE when we don\'t match a filter');
				matches_filter = true;
			}
				
			this.configuration.filters.fields.forEach((field) => {
				// console.log('Values: ', field['values']);
				// console.log('Data: ', data[field['fieldname']]);
				// console.log('Index:', _.indexOf(field['values'], data[field['fieldname']]));
				// If the logic is OR, we can return TRUE as soon as we have a match
				if ((this.configuration.filters.logic === 'or') && (_.indexOf(field['values'], data[field['fieldname']]) >= 0)) {
					// console.log('Returning true');
					matches_filter = true;
				}
				// If the logic is AND, we can return FALSE as soon as we don't have a match
				if ((this.configuration.filters.logic === 'and') && (_.indexOf(field['values'], data[field['fieldname']]) < 0)) {
					// console.log('Returning false');
					matches_filter = false;
				}
			});
			
			if (this.configuration.filters.type === 'exclude') {
				// console.log('Returning exclude filter');
				return !matches_filter;
			}
			else {
				// console.log('Returning include filter');
				return matches_filter;
			}
			
			// if (results.data['Member Status'] == 'Anonymized') {
			// 	return;
			// }
			// if (results.data['Member Status'] == 'Cancelled/Hidden') {
			// 	return;
			// }

		},
		
			

	}
}
</script>